import styles from "./Cookies.module.css";
import { Link } from "react-router-dom";
import { useCookies } from "./useCookies";
import { cookieContent } from "../../data/landingpage";

const Cookies = () => {
  const { preference, handlePreferenceChange } = useCookies();

  if (preference !== null) {
    return null;
  }

  return (
    <div className={styles.cookieConsent}>
      <div className={styles.content}>
        <h2 className={styles.title}>{cookieContent.title}</h2>
        <p className={styles.description}>
          {cookieContent.description}{" "}
          <Link to="/privacy" className={styles.cookiesLink}>
            privacy policy.
          </Link>
        </p>
      </div>
      <div className={styles.buttons}>
        <button
          className={styles.acceptButton}
          onClick={() => handlePreferenceChange("accepted")}
        >
          {cookieContent.buttons.accept}
        </button>
        <button
          className={styles.declineButton}
          onClick={() => handlePreferenceChange("declined")}
        >
          {cookieContent.buttons.reject}
        </button>
      </div>
    </div>
  );
};

export default Cookies;
